import React, { useEffect } from "react";
import {
  FaTools,
  FaProjectDiagram,
  FaShieldAlt,
  FaClock,
  FaCheckCircle,
  FaCogs,
  FaBolt,
  FaMicrochip,
} from "react-icons/fa";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import collab from "../../assets/collab.png";
import ERPChatbot from "../../components/ERPChatbot/ERPChatbot";
import "./CableAssembly.css";

export default function CableAssembly() {
  const stages = [
    {
      icon: <FaTools className="cable-step-icon" />,
      title: "Design & Prototyping",
      desc: "Creating cable assembly prototypes with precise specifications.",
    },
    {
      icon: <FaProjectDiagram className="cable-step-icon" />,
      title: "Assembly & Testing",
      desc: "High-quality assembly processes followed by rigorous testing.",
    },
    {
      icon: <FaShieldAlt className="cable-step-icon" />,
      title: "Quality Assurance",
      desc: "Ensuring compliance with international standards and safety.",
    },
    {
      icon: <FaClock className="cable-step-icon" />,
      title: "On-time Delivery",
      desc: "Streamlined production processes for timely delivery.",
    },
  ];

  const benefits = [
    { title: "Custom Solutions", desc: "Tailored cable assemblies for unique requirements." },
    { title: "Durability", desc: "Built for performance in demanding environments." },
    { title: "Scalability", desc: "Supporting small to large-scale production runs." },
  ];

  const capabilities = [
    { icon: <FaBolt />, text: "High-voltage cable assembly expertise" },
    { icon: <FaMicrochip />, text: "Integration with electronic control systems" },
    { icon: <FaCogs />, text: "Precision manufacturing with advanced tools" },
    { icon: <FaCheckCircle />, text: "Certified processes ensuring reliability" },
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="cable-page-content">
      <Header />

      {/* Hero Section */}
      <section
        className="cable-hero"
        style={{ backgroundImage: `url(${collab})` }}
      >
        <div className="cable-hero-overlay"></div>
        <h1 className="cable-hero-title">MES for Cable Assembly Process</h1>
      </section>

      {/* Intro Section */}
      <section className="cable-hero-content">
        <h2>Streamline Your Cable Assembly Manufacturing</h2>
        <p>
          Our MES solutions for cable assembly ensure precision, efficiency, and
          compliance at every stage of the process. From prototyping to
          large-scale production, we deliver quality you can trust.
        </p>
      </section>

      {/* Key Stages */}
      <section className="cable-process-flow">
        <h2>Key Stages</h2>
        <div className="cable-process-steps">
          {stages.map((stage, i) => (
            <div key={i} className="cable-step">
              {stage.icon}
              <h3>{stage.title}</h3>
              <p>{stage.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="cable-benefits">
        <h2>Why Choose Us?</h2>
        <div className="cable-benefits-grid">
          {benefits.map((benefit, i) => (
            <div key={i} className="cable-benefit">
              <h3>{benefit.title}</h3>
              <p>{benefit.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Capabilities Section */}
      <section className="cable-features">
        <h2>Our Capabilities</h2>
        <ul>
          {capabilities.map((cap, i) => (
            <li key={i}>
              <span className="feature-icon">{cap.icon}</span>
              {cap.text}
            </li>
          ))}
        </ul>
      </section>

      <Footer />
      <ERPChatbot />
    </div>
  );
}
